import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { ActivatedRoute } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-contexts-context-dashboard',
  templateUrl: './contexts-context-dashboard.component.html',
  styleUrls: ['./contexts-context-dashboard.component.scss']
})
export class ContextsContextDashboardComponent implements OnInit, OnDestroy {

  context;
  getContextSubscriptionRefresh: Subscription;
  getContextInfoSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
    private contextsService: ContextsContextsService,
    private snackbarService: SnackBarService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getContextInfo();
    this.getContextSubscriptionRefresh = this.contextsService.refreshContextListen().pipe(
      tap(o => this.getContextInfo())
    ).subscribe();
  }

  private getContextInfo() {
    const internalId = this.activatedRoute.snapshot.params['contextid'];
    this.getContextInfoSubscription = this.contextsService.getContextInfo(internalId).pipe(
      tap(o => this.context = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-hdd', 'apisecrets-page.apisecret detail', '/account/contexts', [new BRoute('account-page.account', '/account'), new BRoute('apisecrets-page.apisecrets', '/account/contexts'), new BRoute('apisecrets-page.apisecret detail')]));
  }

  ngOnDestroy() {
    if (this.getContextSubscriptionRefresh) { this.getContextSubscriptionRefresh.unsubscribe(); }
    if (this.getContextInfoSubscription) { this.getContextInfoSubscription.unsubscribe(); }
  }
}
